export default __webpack_public_path__ + "static/media/Volume Off.59fe893f.svg";